module.exports = __webpack_public_path__ + "img/illus_11.fcb90b64.png";